<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i> 企业用户管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
                        <div class="handle-box">

                            <el-select v-model='enterpiseValue' placeholder='企业' style='width: 140px;margin-right: 20px'>
                                <el-option
                                    v-for='item in enterpiseOptions'
                                    :key='item.value'
                                    :label='item.label'
                                    :value='item.value'>
                                </el-option>
                            </el-select>

                            <el-button type="primary" icon="el-icon-search" @click="handleSearch">查询</el-button>
                            <el-button
                                type="primary"
                                icon="el-icon-plus"
                                class="handle-del mr10"
                                @click="addUser"
                            >添加企业用户</el-button>
                        </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
            >
                <el-table-column type="selection" width="55" align="center" v-if='false'></el-table-column>
                <el-table-column label='序号' align='center' :index='indexMethod' width='40' type='index'>

                </el-table-column>
                <el-table-column label="用户名称" align="center">
                    <template slot-scope="scope">{{scope.row.name}}</template>
                </el-table-column>
                <el-table-column label="账号" align="center">
                    <template slot-scope="scope">{{scope.row.account}}</template>
                </el-table-column>
                <el-table-column label='状态' align='center'>
                    <template slot-scope='scope'>
                        <el-tag
                            :type="scope.row.status===1?'':'danger'"
                        >{{ scope.row.status === 1 ? '正常' : '禁用' }}
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column prop="createTime" label="创建时间" align="center">
                    <template slot-scope="scope">{{scope.row.createTime}}</template>

                </el-table-column>
                <el-table-column label='操作' width='180' align='center'>
                    <template slot-scope='scope'>
<!--                        <el-button-->
<!--                            type='text'-->
<!--                            icon='el-icon-edit'-->
<!--                            @click='handleEdit(scope.$index, scope.row)'-->
<!--                        >编辑-->
<!--                        </el-button>-->
                        <el-button
                            type='text'
                            icon='el-icon-delete'
                            class='red'
                            @click='handleDelete(scope.$index, scope.row)'
                        >删除
                        </el-button>
                        <el-button
                            type='text'
                            class='blue'
                            @click='handleForbidden(scope.$index, scope.row)'
                        >{{ scope.row.status === 1 ? '禁用' : '解除禁用' }}
                        </el-button>
                    </template>
                </el-table-column>

            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <el-dialog title="编辑企业用户" :visible.sync="editVisible" width="40%">


            <el-form ref="form" :model="form" label-width="70px">
                <el-form-item label="用户昵称">
                    <el-input v-model="form.name" ></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="editHttp">确 定</el-button>
            </span>
        </el-dialog>


        <!-- 添加用户 -->
        <el-dialog title='添加企业用户' :visible.sync='addVisible' width='40%'>


            <el-form ref='form' :model='createForm' label-width='120px'>
                <el-form-item label='所属企业'>
                    <el-select v-model='createForm.enterpriseId' placeholder='请选择'>
                        <el-option
                            v-for='item in enterpiseOptions'
                            :key='item.value'
                            :label='item.label'
                            :value='item.value'>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='用户名'>
                    <el-input v-model='createForm.name' maxlength='11'></el-input>
                </el-form-item>
                <el-form-item label='账号'>
                    <el-input v-model='createForm.account' maxlength='11' ></el-input>
                </el-form-item>
                <el-form-item label='密码'>
                    <el-input v-model='createForm.password' maxlength='11'></el-input>
                </el-form-item>

            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='addVisible = false'>取 消</el-button>
                <el-button type='primary' @click='addUserHttp'>确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { countDown, formatDate, formatDates } from '@/utils/formatDate';
export default {
    name: 'basetable',
    data() {
        return {
            queryEnterprise: {
                name: '',
                pageIndex: 1,
                pageSize: 999999
            },
            enterpiseOptions: [],
            enterpiseValue: '',
            query: {
                enterpriseId: '',
                pageIndex: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            addVisible:false
            ,
            createForm:{}
            ,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1,
            options: [],
            value: '',
            editCurrentProgress:"1",
            editCurrentProgressName:""


        };
    },
    created() {
        this.getEnterpise();
        this.getData();

    },
    filters: {
        //方法一
        fmtime(val) {
            return formatDate(val);
        },
//使用封装中的方法二
        formatTime(val){
            let data=new Date(val)
            return  formatDates(data,'yyyy-MM-dd hh:mm');
        },
        countDown(val){
            return  countDown(val);
        }
    },

    methods: {
        indexMethod(index) {
            return index + 1;
        },
        getEnterpise() {
            let that = this;
            this.http.getToken('/enterprise/getList', this.queryEnterprise).then(res => {
                    if (res.code == 0) {
                        that.enterpiseOptions.push({ 'value': '', 'label': '请选择企业' });
                        res.data.records.forEach(res => {
                            that.enterpiseOptions.push({ 'value': res.id, 'label': res.name });
                        });

                    }
                },
                err => {


                });
        },

        // 触发搜索按钮
        handleSearch() {
            this.query.pageIndex=1
            this.getData();

        }
        ,
        //禁用
        handleForbidden(index, row) {
            // 二次确认删除
            console.log(index);
            console.log(row.uid);
            let that = this;
            let params = {};
            let msg = '';
            if (row.status == 1) {
                msg = '确定要' + '禁用' + '吗？';
                params = { 'id': row.id, 'status': 0 };
            } else {
                msg = '确定要' + '解除禁用' + '吗？';
                params = { 'id': row.id, 'status': 1 };
            }
//0不可用1可用
            this.$confirm(msg, '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.postToken('/enterpriseUser/updateStatusUser', params).then(res => {
                        if (res.code == 0) {
                            that.getData();
                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });
        },
        getData() {
            let that = this
            this.query.enterpriseId=this.enterpiseValue
            this.http.getToken("enterpriseUser/getListData",this.query).then(res=>{
                    if (res.code==0) {
                        that.tableData = res.data.records;
                        that.pageTotal=parseInt(res.data.total)
                        this.$message.success("获取数据成功")

                    }
                },
                err=>{

                })
        },
        delUserHttp(id){
            let that = this
            this.http.postToken("enterpriseUser/delUserById",{"id":id}).then(res=>{
                    if (res.code == 0) {
                        that.getData()
                        that.$message.success('删除成功');
                    }
                },
                err=>{

                })
        }
        ,
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            let that = this
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delUserHttp(row.id)

                })
                .catch(() => {});
        },

        addUser(){
            this.addVisible = true;
            this.createForm={}
        },

        addUserHttp(){
            let that = this
            this.http.postToken("enterpriseUser/add",this.createForm).then(res=>{
                if (res.code ===0){
                    that.getData()
                    that.addVisible=false
                    this.$message.success("添加成功")
                }

            })
        }
        ,
        editHttp(){
            let that = this
            this.options.forEach(function(element) {
                if (element.name === that.editCurrentProgressName){
                    that.editCurrentProgress=element.type
                }

            })
            console.log(that.editCurrentProgressName)
            console.log(that.editCurrentProgress)
            that.form.currentProgress=that.editCurrentProgress
            this.http.postToken("api/company/edit",this.form).then(res=>{
                if (res.code == 0){
                    that.getData()
                    that.editVisible=false
                    that.$message.success("编辑成功")
                }

            })
        }
        ,
        // 编辑操作
        handleEdit(index, row) {
            this.idx = index;

            this.form = JSON.parse( JSON.stringify(row) );
            this.editCurrentProgressName=this.form.currentProgressName

            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
            this.editVisible = false;
            this.$message.success(`修改第 ${this.idx + 1} 行成功`);
            this.$set(this.tableData, this.idx, this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.avatar-uploader .el-upload {
    border-radius: 6px;
    width: 80px;
    height: 80px;
    text-align: center;

}
.avatar-uploader  {
    border-color: #409EFF;
    text-align: center;
    margin-bottom: 40px;
    text-align: center;

}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    text-align: center;
}
.avatar {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto auto;
    text-align: center;
}
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
